<script setup>
import { computed } from "vue";

/**
 * Inline line icons.
 *
 * The icon set lives as individual SVG files in `src/icons/`. They are pulled in
 * at build time with Vite's glob import (`?raw`), so each is inlined into the
 * bundle — no icon font, no CDN, no runtime fetch (CSP-safe). Because they are
 * inlined rather than loaded as <img>, `stroke="currentColor"` resolves against
 * the surrounding element, letting a card tint its own icon.
 *
 * To add an icon: drop `src/icons/<name>.svg` in the folder and reference it by
 * `<name>`. Nothing here needs to change.
 *
 * The markup is author-controlled build input — no user data reaches the v-html.
 */
const props = defineProps({
  name: { type: String, required: true }
});

// Eagerly inline every icon file as a raw string, keyed by its base name.
const modules = import.meta.glob("../icons/*.svg", { query: "?raw", import: "default", eager: true });
const ICONS = {};
for (const path in modules) {
  ICONS[path.slice(path.lastIndexOf("/") + 1, -4)] = modules[path];
}

const svg = computed(() => ICONS[props.name] || "");
</script>

<template>
  <span class="app-icon" aria-hidden="true" v-html="svg"></span>
</template>

<style scoped>
.app-icon { display: inline-flex; line-height: 0; }
</style>
